import * as React from "react";

export const IndicatorStoreIcon = (props: any) => (
  <svg
    width={24}
    height={18}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 0v2.742l-2.25 3V6c0 .61.219 1.14.656 1.594A2.22 2.22 0 0 0 3 8.25V18h12v-6.75h1.5V18H21V8.25c.61 0 1.133-.219 1.57-.656.453-.453.68-.985.68-1.594v-.258l-2.25-3V0H3Zm1.5 1.5h15v.75h-15V1.5Zm-.375 2.25h15.75l1.805 2.414a.84.84 0 0 1-.258.422.571.571 0 0 1-.422.164.782.782 0 0 1-.54-.21.782.782 0 0 1-.21-.54h-1.5a.74.74 0 0 1-.234.54.701.701 0 0 1-.516.21.782.782 0 0 1-.54-.21.782.782 0 0 1-.21-.54h-1.5a.74.74 0 0 1-.234.54.701.701 0 0 1-.516.21.782.782 0 0 1-.54-.21.782.782 0 0 1-.21-.54h-1.5a.74.74 0 0 1-.234.54.701.701 0 0 1-.516.21.782.782 0 0 1-.54-.21.782.782 0 0 1-.21-.54h-1.5a.741.741 0 0 1-.234.54.701.701 0 0 1-.516.21.782.782 0 0 1-.54-.21.782.782 0 0 1-.21-.54h-1.5a.741.741 0 0 1-.234.54.701.701 0 0 1-.516.21.782.782 0 0 1-.54-.21.782.782 0 0 1-.21-.54h-1.5a.741.741 0 0 1-.234.54.701.701 0 0 1-.516.21.654.654 0 0 1-.445-.164.928.928 0 0 1-.235-.422L4.125 3.75ZM4.5 7.664c.438.39.938.586 1.5.586.563 0 1.063-.195 1.5-.586.438.39.938.586 1.5.586.563 0 1.063-.195 1.5-.586.438.39.938.586 1.5.586.563 0 1.063-.195 1.5-.586.438.39.938.586 1.5.586.563 0 1.063-.195 1.5-.586.438.39.938.586 1.5.586.563 0 1.063-.195 1.5-.586V16.5H18V9.75h-4.5v6.75h-9V7.664ZM6 9.75V15h6V9.75H6Zm1.5 1.5h3v2.25h-3v-2.25Z"
      fill="#424248"
    />
  </svg>
);
